export const toObject = async (source, selector) => {
    const map = {};
    for await (const value of source) {
        map[selector(value)] = value;
    }
    return map;
};
